import { Slide } from "react-reveal";
import whatsAppIcon from "../assets/images/icons/whatsapp-business-icon.svg";

const FloatingButton = () => {
  return (
    <div className="relative">
      <div className="floating-button-container">
        <Slide right>
          <button className="whatsapp-button button">
            <a
              href="https://wa.me/256756363333"
              target="_blank"
              rel="noopener noreferrer"
              title="WhatsApp Uganda School of ICT"
            >
              <img
                src="https://res.cloudinary.com/malidad/image/upload/v1778294470/whatsapp-business-icon_frgk3p.svg"
                class="icon"
                alt="Whatsapp Icon"
              />
            </a>
          </button>
        </Slide>
      </div>
    </div>
  );
};

export default FloatingButton;
